import { useState, useEffect } from 'react';
import Select from 'react-select';
import { _single } from '../../../core/services/dataBean/EntityCatalog';

interface Props {
    idSelector: number;
    onChange: any;
    label?: string;
    returnType?: "ID" | "Object";
}

export const SelectIDWorkGroupBPMSingleton = ({ idSelector, onChange, label, returnType = "ID" }: Props) => {
    const lista = _single.getMyGroupsBPM();
    const [selectedOption, setSelectedOption] = useState<any>(null);

    useEffect(() => {
        if (idSelector && lista.length > 0) {
            const found = lista.find(item => item.IDWorkGroupMember === idSelector);
            if (found) {
                setSelectedOption({
                    value: found.IDWorkGroupMember,
                    label: `${found.Name} - ${found.JsonCodeName}`,
                    item: found
                });
            }
        }
    }, [idSelector, lista]);

    const handleChange = (option: any) => {
        setSelectedOption(option);
        if (!option) {
            if (onChange)
                onChange(returnType === "Object" ? {} : null);
        } else {

            if (onChange) {
                onChange(returnType === "Object" ? option.item : option.value);
            }
        }
    };

    const options = lista.map((item: any) => ({
        value: item.IDWorkGroupMember,
        label: `${item.Name} - ${item.JsonCodeName}`,
        item: item
    }));

    return (
        <div>
            {label !== " " && (
                <label>{label || "Grupos de Trabajo Asignados"}</label>
            )}
            <Select
                options={options}
                value={selectedOption}
                onChange={handleChange}
                isClearable
                placeholder="Selecciona un Grupo..."
                noOptionsMessage={() => "Sin coincidencias"}
            />
        </div >
    );
};
